// Server-sanitized legal HTML with consistent typography.
export function PolicyBody({ html, testId = "policy-body" }) {
  return (
    <div data-testid={testId}
      className="text-[15px] leading-relaxed text-stone-800 break-words [&_h2]:font-display [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-stone-900 [&_h2]:mt-7 [&_h2]:mb-2 [&_h3]:text-sm [&_h3]:font-semibold [&_h3]:tracking-wide [&_h3]:text-amber-900 [&_h3]:mt-4 [&_h3]:mb-1 [&_p]:my-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_li_p]:my-0.5 [&_a]:text-amber-800 [&_a]:underline"
      dangerouslySetInnerHTML={{ __html: html }} />
  );
}
